module.exports = __webpack_public_path__ + "static/media/YM79_3.49e06e60.jpg";